import { throttle } from 'lodash';

import { initializeAOS } from './modules/aos-setup.js';
import { initializeHubSpotForm } from './modules/hubspot-load.js';
import { initializeNavbar } from './modules/navbar.js';
import { initializeRunningText } from './modules/running-text.js';
import { initializeCounterAnimation } from './modules/counter-animation.js';
import { initializeTextSlider, showTextSlide, changeTextSlide } from './modules/text-slider.js';
import { initializeGlowPoints } from './modules/glow-points.js';
import { initializeHeroSlider } from './modules/simple-hero-slider.js';
import { initializeDropdowns } from './modules/dropdowns.js';
import { initializeTooltips } from './modules/tooltips.js';
import { initializeTimeline } from './modules/timeline.js';
import { initializeLogoCarousel } from './modules/logo-carousel.js';
import { initializeCaseStudyV2 } from './modules/case-study-v2.js';

const ERROR_MESSAGES = {
	INIT_FAILED: 'Application: Failed to initialize components',
	SCROLL_ERROR: 'Application: Error handling scroll',
};

// Make the text slider functions available globally
window.showTextSlide = showTextSlide;
window.changeTextSlide = changeTextSlide;

/**
 * Initialize all components
 * @returns {void}
 */
export const initializeComponents = () => {
	try {
		// Initialize AOS
		initializeAOS();

		// Initialize navigation components
		initializeNavbar();
		initializeDropdowns();

		// Initialize text components
		initializeRunningText();
		initializeTextSlider();

		// Initialize animations
		initializeCounterAnimation();
		initializeGlowPoints();
		initializeHeroSlider();
		initializeTimeline();

		// Initialize UI components
		initializeTooltips();
		initializeLogoCarousel();

		// Initialize page-specific components
		initializeCaseStudyV2();

		// initialize HubSpot form
		initializeHubSpotForm();

		/* const toggleButton = document.getElementById('toggleAOS');
		if (toggleButton) {
			toggleButton.addEventListener('click', toggleAOSAnimations);
		} */
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

/**
 * Handle scroll events for navbar
 * @returns {void}
 */
const handleScroll = () => {
	try {
		initializeNavbar();
	} catch (error) {
		console.error(ERROR_MESSAGES.SCROLL_ERROR, error);
	}
};

// Initialize components when DOM is ready
document.addEventListener('DOMContentLoaded', initializeComponents);

// Throttle scroll event for better performance
window.addEventListener('scroll', throttle(handleScroll, 100));

// Throttle resize event for running text
window.addEventListener('resize', throttle(initializeRunningText, 250));
